var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9793 6.17916C17.4848 5.68012 17.4854 4.87011 16.9806 4.37038L13.5943 1.01764C13.0901 0.518373 12.2722 0.517811 11.7672 1.01639L2.28519 10.3784C2.03152 10.6288 1.85299 10.944 1.76944 11.2887L0.681342 15.779C0.449965 16.7338 1.34766 17.5796 2.30031 17.3044L6.64702 16.0486C6.95893 15.9585 7.24295 15.7923 7.47296 15.5651L16.9793 6.17916ZM13.1572 8.14657L6.56004 14.6601C6.48341 14.7359 6.38872 14.7913 6.28474 14.8213L2.6829 15.8619C2.35098 15.9577 2.03929 15.6593 2.12066 15.3236L3.02616 11.5868C3.05402 11.4719 3.11353 11.3669 3.19808 11.2834L9.76989 4.79481L13.1572 8.14657ZM14.072 7.24342L10.6847 3.89164L12.2279 2.36797C12.4785 2.12053 12.8816 2.1208 13.1318 2.3686L15.6045 4.81668C15.8588 5.06848 15.8585 5.47951 15.6038 5.73096L14.072 7.24342Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilWhite);
export default __webpack_public_path__ + "static/media/pencil-white.c10ee84e3210a86a5d972c23ab76b60d.svg";
export { ForwardRef as ReactComponent };